import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaBdrule_2.mjs'
import FormChoose from './FormChooseBdrule_2.jsx'
import TableChoose from './TableChooseBdrule_2.jsx'
import api from './apiBdrule_2.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
